import withCompController from '../../VideoBox/viewer/VideoBox.controller';

export default withCompController;
